export default {"src":"/_next/static/media/filter.3cec0aee.svg","height":800,"width":800};